import '../../assets/components/ProductCardList/productcardlist.css';const t = "_productcardlistBody_e59oa_1", o = "_horizontal_e59oa_23", c = "_productcardlistButton_e59oa_28", d = {
  productcardlistBody: t,
  horizontal: o,
  productcardlistButton: c
};
export {
  d as default,
  o as horizontal,
  t as productcardlistBody,
  c as productcardlistButton
};
